import React from "react"

// Components
import GoogleMap from "./gmaps"

const Appointment = () => {



  return (
    <section className="grid grid-cols-12 mt-20 bg-light_brown" id="appointment" style={{ minHeight: 600 }}>
      <div id="location" className="col-span-12">
        <GoogleMap />
      </div>
    </section>
  )

}

export default Appointment